import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForCollectionComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'headline',
    'artists',
    'type',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'artists',
      type: 'relation',
    },
    {
      property: 'type',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
